<template>
  <!--保养-->
  <ZhaiHead></ZhaiHead>
  <div class="container-fluid zhu py-2">
    <!--三个按钮-->
    <ZhaiThreeTuttons></ZhaiThreeTuttons>
    <!--三个按钮-->
    <!--二个按钮2-->
    <ZhaiTwoTuttons2></ZhaiTwoTuttons2>
    <!--二个按钮2-->
  </div>

  <!--二个按钮-->
  <div class="full-bleed-grid">
    <ZhaiTwoTuttons></ZhaiTwoTuttons>
  </div>
  <!--二个按钮-->

  <div class="container-fluid">
    <!-- 省份 -->
    <div class="row shengse py-4 mt-2 mb-2">
      <div class="col-2 sheng jiacu" style="text-align:right">省份：</div>
      <div class="col-10">
        <a
            v-for="province in provinces"
            :key="province.name"
            class="G-FilterItem Field zitiyanse shengpdhh"
            :class="{ active: selectedProvince.name === province.name }"
            @click.prevent="selectProvince(province)"
            style="max-width:72px;"
            href="#"
        >
          <span class="Text">{{ province.name }}</span>
        </a>
      </div>
    </div>

    <!-- 这个隐藏挂载点只负责让子组件请求数据，不占页面空间 -->
    <div class="banner-probe">
      <VipUpgradeDiffBanner
          ref="vipDiffBanner"
          :user-id="getUser && getUser.id"
          :text-prefix="homeUpgradePrefix"
          @select="handleSelectPermanentUpgrade"
      />
    </div>

  </div>
  <!-- 只有真正满足补差价条件时，才显示页面里的红条 -->
  <div
      v-if="showUpgradeBanner"
      class="container-fluid px-0"
  >
    <div class="home-diff-banner-wrap" @click="triggerBannerClick">
      <div class="home-diff-banner-text">
        {{ fullBannerText }}
      </div>
    </div>
  </div>

  <!-- 列表 -->
  <div class="container-fluid px-0">
    <div class="row card-container">
      <div class="col-md-4 mb-1" v-for="item in items" :key="item.id">
        <!-- 统一用 query 方式进入详情 -->
        <router-link class="no-underline" :to="{ path: '/details', query: { id: item.id } }">
          <MaintenanceCard :data="item" />
        </router-link>
      </div>
    </div>

    <!-- 分页 -->
    <div class="bg-white my-2 p-3 G-Field" style="text-align:center;">
      <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <a class="page-link" href="#" aria-label="Previous"
               @click.prevent="pushFiltersToRoute(currentPage - 1)">
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>

          <li class="page-item"
              v-for="page in paginationPages"
              :key="page"
              :class="{ active: currentPage === page }">
            <a class="page-link" href="#"
               @click.prevent="page !== '...' && pushFiltersToRoute(page)">
              {{ page }}
            </a>
          </li>

          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <a class="page-link" href="#" aria-label="Next"
               @click.prevent="pushFiltersToRoute(currentPage + 1)">
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>

  <!-- 升级支付 模态框 -->
  <div class="modal fade" id="upgradeModal" tabindex="-1" aria-labelledby="upgradeModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="upgradeModalLabel">升级支付</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div id="step1">
            <div>
              请选择支付宝或微信支付，请确认升级的VIP类型及支付金额是否正确，点击“支付”进行支付。
            </div>
            <div class="mt-2">
              <strong>升级类型：</strong>
              <span id="uplevel">{{ modalData.type }}</span>
            </div>
            <div class="mt-2">
              <strong>支付金额：</strong>
              <span id="payamount">{{ modalData.amount }}元</span>
            </div>
            <div class="mt-2">
              <strong>支付方式：</strong>
              <label class="pay-option1">
                <input type="radio" name="paytype" value="alipay" v-model="payType" id="alipay">
                支付宝（推荐）
              </label>
              <label class="pay-option">
                <input type="radio" name="paytype" value="wechat" v-model="payType" id="wechat">
                微信（备用）
              </label>
            </div>

            <div class="mt-2" style="color:red;">
              如果支付加载不出来，多试几次就成功了。
            </div>

            <div class="text-center mt-5 d-flex justify-content-center gap-4">
              <button id="startPayBtn" class="btn btn-success" @click="startPayment">支付</button>
              <button class="btn btn-success" data-bs-dismiss="modal">关闭</button>
            </div>
          </div>

          <div id="step2" style="display:none;">
            <!-- 支付结果提示：直接显示在二维码区域内，不再打开第二个提示框 -->
            <transition name="payment-notice">
              <div
                  v-if="paymentNotice.visible"
                  class="payment-inline-notice"
                  :class="{
                            'payment-inline-success': paymentNotice.type === 'success',
                            'payment-inline-error': paymentNotice.type === 'error'
                          }"
              >
                <i
                    v-if="paymentNotice.type === 'success'"
                    class="bi bi-check-circle-fill payment-notice-icon"
                ></i>
                <i
                    v-else
                    class="bi bi-emoji-frown payment-notice-icon"
                ></i>
                <span>{{ paymentNotice.message }}</span>
              </div>
            </transition>

            <div id="paymsg" style="text-align: center;font-size: 1rem;font-weight: bold;"></div>
            <p id="code_msg" style="text-align: center;background: #040404;color: #ffeb00;font-size: 1rem;">
              如页面出现支付步骤文字说明，请务必看完（尤其是付款注意事项）再进行支付。
            </p>
            <p style="text-align: center;font-size: 1rem;color: #000;">
              请确认支付完成后，再点击“支付完成”
            </p>
            <div class="text-center d-flex justify-content-center gap-4">
              <button id="btnpaysucess" class="btn btn-primary" @click="onManualCheckPayment">
                支付完成
              </button>
              <button class="btn btn-primary" data-bs-dismiss="modal">
                关闭
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ZhaiFoot />
</template>

<script>
import ZhaiHead from "../components/ZhaiHead";
import ZhaiFoot from "../components/ZhaiFoot";
import ZhaiThreeTuttons from "../components/ZhaiThreeTuttons";
import ZhaiTwoTuttons from "../components/ZhaiTwoTuttons";
import ZhaiTwoTuttons2 from "../components/ZhaiTwoTuttons2";
import MaintenanceCard from "../components/MaintenanceCard";
import VipUpgradeDiffBanner from "../components/VipUpgradeDiffBanner.vue";
import http from "../utils/http.js";
import { mapGetters } from "vuex";
import { Modal } from "bootstrap";
import QRCode from "qrcodejs2";

export default {
  name: "MMaintenance",

  components: {
    ZhaiHead,
    ZhaiFoot,
    ZhaiThreeTuttons,
    ZhaiTwoTuttons,
    MaintenanceCard,
    ZhaiTwoTuttons2,
    VipUpgradeDiffBanner
  },

  data() {
    return {
      items: [],
      currentPage: 1,
      totalPages: 1,
      sortBy: "publishTime",
      selectedProvince: { name: "全部" },
      provinces: this.getProvinces(),
      provinceKeyword: "",

      modalData: { type: "", amount: 0 },
      payType: "alipay",
      orderId: null,
      manualPolling: false,

      // 二维码区域内的成功/失败提示
      paymentNotice: {
        visible: false,
        type: "",
        message: ""
      },
      paymentNoticeTimer: null,

      showUpgradeBanner: false,
      bannerSyncTimer: null
    };
  },

  mounted() {
    this.restoreFromQuery();
    this.startBannerSync();
  },

  activated() {
    // this.restoreFromQuery();
  },

  beforeUnmount() {
    this.stopBannerSync();
    this.hidePaymentNotice();
  },

  watch: {
    "$route.query": {
      handler() {
        this.restoreFromQuery();
      },
      immediate: false
    }
  },

  computed: {
    ...mapGetters(["getUser"]),

    paginationPages() {
      const pages = [];
      const start = Math.max(1, this.currentPage - 2);
      const end = Math.min(this.totalPages, this.currentPage + 2);

      for (let i = start; i <= end; i++) pages.push(i);

      if (start > 1) {
        if (start > 2) pages.unshift("...");
        pages.unshift(1);
      }

      if (end < this.totalPages) {
        if (end < this.totalPages - 1) pages.push("...");
        pages.push(this.totalPages);
      }

      return pages;
    },

    homeUpgradePrefix() {
      const username = this.getUser?.username || "会员";
      return `尊敬的会员 ${username}：限时补差价 `;
    },

    fullBannerText() {
      const banner = this.$refs.vipDiffBanner;
      if (!banner || !banner.upgradeInfo) return "";

      const username = this.getUser?.username || "会员";
      const price = banner.displayPrice(banner.upgradeInfo.upgradePrice);
      const countdown = banner.countdownText || "";

      return `尊敬的会员 ${username}：限时补差价 ${price}元，即可升级为永久会员！${countdown ? `（剩余${countdown}）` : ""}`;
    }
  },

  methods: {
    startBannerSync() {
      this.stopBannerSync();

      this.bannerSyncTimer = setInterval(() => {
        const banner = this.$refs.vipDiffBanner;
        if (!banner) {
          this.showUpgradeBanner = false;
          return;
        }

        this.showUpgradeBanner = !!banner.visible;
      }, 500);
    },

    stopBannerSync() {
      if (this.bannerSyncTimer) {
        clearInterval(this.bannerSyncTimer);
        this.bannerSyncTimer = null;
      }
    },

    triggerBannerClick() {
      const banner = this.$refs.vipDiffBanner;
      if (banner && typeof banner.handleClick === "function") {
        banner.handleClick();
      }
    },

    handleSelectPermanentUpgrade(payload) {
      this.modalData.type = payload.type;
      this.modalData.amount = payload.amount;
      this.openModal();
    },

    openModal() {
      this.hidePaymentNotice();
      this.orderId = null;
      this.manualPolling = false;

      document.getElementById("step1").style.display = "block";
      document.getElementById("step2").style.display = "none";

      const paymsg = document.getElementById("paymsg");
      if (paymsg) {
        paymsg.innerHTML = "";
      }

      const modalElement = document.getElementById("upgradeModal");
      const modalInstance = Modal.getOrCreateInstance(modalElement);
      modalInstance.show();
    },

    resetPayButton() {
      const payButton = document.getElementById("startPayBtn");
      if (payButton) {
        payButton.textContent = "支付";
        payButton.disabled = false;
      }
    },

    startPayment() {
      this.hidePaymentNotice();
      this.orderId = null;
      this.manualPolling = false;

      const payButton = document.getElementById("startPayBtn");
      if (payButton) {
        payButton.textContent = "生成中";
        payButton.disabled = true;
      }

      const { id: userid, username, email } = this.getUser || {};
      if (!userid || !username || !email) {
        this.resetPayButton();
        alert("用户信息不完整，请重新登录！");
        return;
      }

      let requestUrl = "";

      if (this.modalData.type === "限时补差价升级永久会员") {
        requestUrl = `/platform/frontEndPayment/requestPermanentUpgrade?userid=${userid}&username=${encodeURIComponent(username)}&email=${encodeURIComponent(email)}&paytype=${this.payType}`;
      } else {
        requestUrl = `/platform/frontEndPayment/request?name=${encodeURIComponent(this.modalData.type)}&money=${this.modalData.amount}&userid=${userid}&username=${encodeURIComponent(username)}&email=${encodeURIComponent(email)}&paytype=${this.payType}`;
      }

      http.get(requestUrl)
          .then(response => {
            const res = response.data;

            if (res && res.status === 1 && res.data) {
              const { payUrl, mchOrderNo } = res.data;

              if (!payUrl) {
                this.resetPayButton();
                this.showFailureNotice("支付链接为空，请联系管理员！");
                return;
              }

              this.orderId = mchOrderNo;
              this.generateQRCode(payUrl);
            } else {
              this.resetPayButton();
              const errorMessage = res?.msg || "未知错误";
              this.showFailureNotice(`支付请求失败：${errorMessage}`);
            }
          })
          .catch(error => {
            this.resetPayButton();
            this.showFailureNotice(`请求支付失败，请重试。错误详情: ${error.message}`);
          });
    },

    generateQRCode(payUrl) {
      if (this.payType === "wechat") {
        document.getElementById("paymsg").innerHTML =
            "截图并保存二维码，然后使用微信扫一扫付款。";
      } else {
        document.getElementById("paymsg").innerHTML =
            "请用手机相机扫描下方二维码，从浏览器打开，将自动跳转支付宝支付。也可截图并保存二维码，然后使用支付宝扫一扫付款。";
      }

      const qrCodeContainer = document.createElement("div");
      qrCodeContainer.id = "qrcode";
      qrCodeContainer.style.width = "200px";
      qrCodeContainer.style.height = "200px";
      qrCodeContainer.style.marginTop = "20px";

      document.getElementById("paymsg").appendChild(qrCodeContainer);

      new QRCode(qrCodeContainer, {
        text: payUrl,
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        // ✅ 统一改 L（稳定）
        correctLevel: QRCode.CorrectLevel.L
      });

      document.getElementById("step1").style.display = "none";
      document.getElementById("step2").style.display = "block";

      let remainingTime = 300;

      const countdown = document.createElement("p");
      countdown.id = "countdown";
      countdown.style.textAlign = "center";
      countdown.style.marginTop = "10px";
      countdown.style.fontWeight = "normal";
      countdown.style.color = "rgba(255, 127, 127)";
      countdown.style.fontSize = "0.9rem";
      document.getElementById("paymsg").appendChild(countdown);

      const timer = setInterval(() => {
        if (remainingTime <= 0) {
          clearInterval(timer);
          countdown.innerHTML = "支付已超时，请关闭重新选择支付！";
          qrCodeContainer.style.filter = "blur(5px)";
          this.resetPayButton();
        } else {
          const minutes = Math.floor(remainingTime / 60);
          const seconds = remainingTime % 60;
          countdown.innerHTML = `请在 ${minutes}:${seconds < 10 ? "0" + seconds : seconds} 内完成支付`;
          remainingTime--;
        }
      }, 1000);
    },

    onManualCheckPayment() {
      this.hidePaymentNotice();
      this.manualPolling = true;
      this.checkPaymentStatus();
    },

    checkPaymentStatus() {
      if (!this.orderId) {
        this.showFailureNotice("订单号不存在，请重新发起支付");
        return;
      }

      const statusUrl =
          `/platform/frontEndPayment/checkPaymentStatus?outTradeNo=${encodeURIComponent(this.orderId)}`;

      http.get(statusUrl)
          .then(response => {
            const data = response.data;

            if (data && data.status === 1) {
              this.manualPolling = false;
              this.handlePaymentSuccessStatus();
            } else {
              this.showFailureNotice("未检测到支付完成，请稍后重试");
            }
          })
          .catch(error => {
            console.error("查询支付状态异常:", error);
            this.showFailureNotice("查询支付状态失败，请稍后重试");
          });
    },

    handlePaymentSuccessStatus() {
      this.$store.dispatch("checkLoginStatus");

      const banner = this.$refs.vipDiffBanner;
      if (banner && typeof banner.refresh === "function") {
        banner.refresh();
      }

      this.fetchPage(this.currentPage || 1);
      this.showSuccessNotice("支付已成功");

      setTimeout(() => {
        const upgradeElement = document.getElementById("upgradeModal");
        const upgradeModal = Modal.getInstance(upgradeElement);

        if (upgradeModal) {
          upgradeModal.hide();
        }
      }, 2000);
    },

    showPaymentNotice(type, message, duration = 3000) {
      if (this.paymentNoticeTimer) {
        clearTimeout(this.paymentNoticeTimer);
        this.paymentNoticeTimer = null;
      }

      this.paymentNotice = {
        visible: true,
        type,
        message
      };

      if (duration > 0) {
        this.paymentNoticeTimer = setTimeout(() => {
          this.hidePaymentNotice();
        }, duration);
      }
    },

    hidePaymentNotice() {
      if (this.paymentNoticeTimer) {
        clearTimeout(this.paymentNoticeTimer);
        this.paymentNoticeTimer = null;
      }

      this.paymentNotice.visible = false;
      this.paymentNotice.type = "";
      this.paymentNotice.message = "";
    },

    showSuccessNotice(message) {
      this.showPaymentNotice("success", message, 0);
    },

    showFailureNotice(message) {
      this.showPaymentNotice("error", message, 3000);
    },

    // 写入 URL
    pushFiltersToRoute(page = 1) {
      const query = {
        ...this.$route.query,
        page,
        sortBy: this.sortBy || "publishTime"
      };

      if (this.selectedProvince?.name && this.selectedProvince.name !== "全部") {
        query.source = this.selectedProvince.name;
      } else {
        delete query.source;
      }

      delete query.city;
      delete query.feature;
      delete query.high;
      delete query.province;

      this.$router.push({ path: "/maintenance", query });
    },

    // 从 URL 还原状态
    restoreFromQuery() {
      const { source, sortBy, page } = this.$route.query;

      this.sortBy = sortBy || "publishTime";

      if (source) {
        const p = this.provinces.find(x => x.name === source) || this.provinces[0];
        this.selectedProvince = p;
        this.provinceKeyword = p.name !== "全部" ? p.name : "";
      } else {
        this.selectedProvince = this.provinces[0];
        this.provinceKeyword = "";
      }

      const pageNum = Number(page) || 1;
      this.fetchPage(pageNum);
      this.updateTitle();
    },

    // 请求数据
    fetchPage(page) {
      if (page === "..." || page < 1 || (this.totalPages && page > this.totalPages)) return;

      const params = new URLSearchParams({
        pageNum: page || 1,
        pageSize: 24,
        sortBy: this.sortBy
      });

      if (this.selectedProvince.name !== "全部") {
        params.append("source", this.selectedProvince.name);
      }

      const url = `/platform/frontEnd/maintenanceList?${params.toString()}`;

      http.get(url)
          .then(res => {
            if (res.data.status === 1) {
              const d = res.data.data || {};
              this.items = d.list || [];
              this.currentPage = d.pageNum || 1;
              this.totalPages = d.pages || 1;
            } else {
              alert(res.data.msg || "请求失败");
            }
          })
          .catch(err => {
            console.error("请求失败:", err);
            alert("请求失败，请稍后重试。");
          });
    },

    changeSort(sortOption) {
      if (this.sortBy === sortOption) return;
      this.sortBy = sortOption;
      this.pushFiltersToRoute(1);
    },

    selectProvince(province) {
      this.selectedProvince = province;
      this.provinceKeyword = province.name !== "全部" ? province.name : "";
      this.updateTitle();
      this.pushFiltersToRoute(1);
    },

    updateTitle() {
      const parts = [this.provinceKeyword].filter(Boolean);
      document.title = parts.length
          ? `${parts.join(" ")}的全部保养信息 - 御凤楼.it.com`
          : "御凤楼.it.com";
    },

    getProvinces() {
      return [
        { name: "全部" },
        { name: "北京" },
        { name: "上海" },
        { name: "天津" },
        { name: "重庆" },
        { name: "河北" },
        { name: "山西" },
        { name: "辽宁" },
        { name: "吉林" },
        { name: "黑龙江" },
        { name: "江苏" },
        { name: "浙江" },
        { name: "安徽" },
        { name: "福建" },
        { name: "江西" },
        { name: "山东" },
        { name: "河南" },
        { name: "湖北" },
        { name: "湖南" },
        { name: "广东" },
        { name: "广西" },
        { name: "海南" },
        { name: "四川" },
        { name: "贵州" },
        { name: "云南" },
        { name: "西藏" },
        { name: "陕西" },
        { name: "甘肃" },
        { name: "青海" },
        { name: "宁夏" },
        { name: "新疆" },
        { name: "香港" },
        { name: "澳门" },
        { name: "台湾" }
      ];
    }
  }
};
</script>

<style scoped>
.G-FilterItem {
  text-decoration: none;
  height: 36px !important;
}

.sheng {
  line-height: 32px;
  padding-right: 0 !important;
}

.jian {
  height: 10px;
}

.shengpdhh {
  padding-left: 8px;
  padding-right: 8px;
  line-height: 32px;
  white-space: nowrap;
}

.zhu {
  margin-top: 80px;
}

.card-container {
  display: flex;
  flex-wrap: wrap;
  margin-left: -1px;
  margin-right: -1px;
}

.col-md-4 {
  padding-left: 2px;
  padding-right: 2px;
}

.G-Field {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
}

.page-link {
  color: #6c757d;
}

.pagination {
  line-height: 1;
  border-color: #dee2e6;
}

.active > .page-link,
.page-link.active {
  background-color: #212429 !important;
  color: white !important;
  border-color: #212429 !important;
}

nav[aria-label="Page navigation example"] {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.pagination {
  display: flex;
  align-items: center;
  margin: 0;
}

/* 这个隐藏挂载点不占位 */
.banner-probe {
  position: absolute;
  left: -99999px;
  top: -99999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
  pointer-events: none;
}

/* 真正显示在页面上的红条 */
.home-diff-banner-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 6px;
  margin-bottom: 6px;

}

.home-diff-banner-text {
  display: block;
  width: 100%;
  background: #ffffff;
  color: #ff2b2b;
  padding: 5px 5px;
  border-radius: 0;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.7;
  box-sizing: border-box;
  cursor: pointer;
}

#btnpaysucess,
.modal-body .btn-primary,
.btn-success {
  background-color: #00c26f !important;
  border: none !important;
}

#paymsg {
  color: #00c26f;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#qrcode {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: filter 0.5s ease;
}

#countdown {
  font-size: 0.7rem;
  color: red !important;
  text-align: center;
}


.payment-inline-notice {
  width: 100%;
  margin: 0 auto 12px;
  padding: 10px 12px;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
}

.payment-inline-success {
  color: #07894f;
  background-color: #e9fff5;
  border: 1px solid #00c26f;
}

.payment-inline-error {
  color: #dc3545;
  background-color: #fff1f2;
  border: 1px solid #f1aeb5;
}

.payment-notice-icon {
  flex-shrink: 0;
  font-size: 1.3rem;
}

.payment-notice-enter-active,
.payment-notice-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.payment-notice-enter-from,
.payment-notice-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.payment-notice-enter-to,
.payment-notice-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.pay-option1 {
  margin-right: 40px;
}
</style>
